module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACGSURBVHgB7ZM7CoVADEVvHq8fK6e189Po1tyJO3EJbsHO1tZOXIBXxUbHJoiIoAdmAuGQQEKAj1vwbFIYPyw17l8jEUwholHxw8U8v+BhMMaPSwg9p28GcrZZb7OE1EPX5DvTLUhBu/bZviW4OVn+AGcwNq6MjSqN+8Itqy5lpucoLT5uYQL78BcXXT0JfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_new/ico-plus.png
// module id = tHau
// module chunks = 1